import { useState } from "react";
import { ArrowUp } from "../icons";
import { useReduxUI } from "../../hooks/redux/useReduxUI";

export const SubMenu = ({ subMenuKey, label, icon, children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const {
		state: { isOpenMenu },
		isMobileView,
	} = useReduxUI();

	return (
		<ul className=" cursor-pointer" key={subMenuKey}>
			<li
				className={`cursor-pointer flex  items-center gap-2 py-5 px-4 justify-start transition-all ${isOpenMenu ? "" : "lg:justify-center"}`}
				onClick={() => {
					isMobileView(true, () => {
						setIsOpen(!isOpen);
					});
				}}
			>
				{icon && <>{icon}</>}
				{isOpenMenu && (
					<>
						<span className={`${!icon ? "pl-6" : ""}`}>{label}</span>
						<ArrowUp isOpen={isOpen} />
					</>
				)}
			</li>
			<div
				className={`pl-6 transition-all duration-300 ease-in-out grid text-white ${
					isOpen && isOpenMenu ? " grid-rows-[1fr]" : " grid-rows-[0fr] text-secondary"
				}`}
			>
				<ul className="overflow-hidden">{children}</ul>
			</div>
		</ul>
	);
};
